import apiClient from '@/constants/http';
// These are the types `transformCartIntoPayloadCart` produces/consumes — the
// api-layer UpsertCartPayload is a different, narrower shape.
import type {
  UpsertCartPayload,
  UpsertCartResponse,
} from '@/hooks/mutations/booking/useUpsertCartMutation';
import { omitKnownCustomerDetails } from '@/utils/bookingCartUtils';

/**
 * Stateless cart validation: recomputes the breakdown from the payload without
 * persisting anything. Unlike the upsert path — which stamps `item.customerId`
 * once and never overwrites it — this re-runs the customer fuzzy-match on every
 * call, so a guest's membership discount re-evaluates as they edit (SQR-15069).
 */
export const validateSale = async (
  shopId: string,
  payload: UpsertCartPayload,
): Promise<UpsertCartResponse> => {
  const { data } = await apiClient.post<UpsertCartResponse>(
    `/v2/shop/${shopId}/sale/validate`,
    omitKnownCustomerDetails(payload),
  );

  return data;
};
